"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3456],{

/***/ 51432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Badge; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js
var CSSTransition = __webpack_require__(29697);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/usePrevious.js
var usePrevious = __webpack_require__(69882);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Badge/count.js
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




function Count(_a) {
    var _b;
    var prefixCls = _a.prefixCls, maxCount = _a.maxCount, count = _a.count, className = _a.className, style = _a.style;
    var _c = __read((0,react.useState)(false), 2), isEntered = _c[0], setIsEntered = _c[1];
    var oldCount = (0,usePrevious/* default */.Z)(count);
    var isChanged = count !== oldCount;
    return (react.createElement(CSSTransition/* default */.Z, { classNames: "badge-zoom", in: count > 0, timeout: 300, appear: true, mountOnEnter: true, unmountOnExit: true, onEntered: function () {
            setIsEntered(true);
        } },
        react.createElement("span", { className: className, style: style },
            react.createElement("span", { key: count, className: (0,classNames/* default */.Z)((_b = {}, _b[prefixCls + "-number-text"] = isEntered && isChanged, _b)) }, maxCount && count > maxCount ? maxCount + "+" : count))));
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Badge/index.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var Badge_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};







var InnerColors = [
    'red',
    'orangered',
    'orange',
    'gold',
    'lime',
    'green',
    'cyan',
    'arcoblue',
    'purple',
    'pinkpurple',
    'magenta',
    'gray',
];
var defaultProps = {
    count: 0,
    maxCount: 99,
};
function Badge(baseProps, ref) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Badge);
    var count = props.count, text = props.text, className = props.className, dotClassName = props.dotClassName, dot = props.dot, maxCount = props.maxCount, color = props.color, propsDotStyle = props.dotStyle, offset = props.offset, style = props.style, status = props.status, children = props.children, restProps = __rest(props, ["count", "text", "className", "dotClassName", "dot", "maxCount", "color", "dotStyle", "offset", "style", "status", "children"]);
    var prefixCls = getPrefixCls('badge');
    var dotStyle = __assign({}, (propsDotStyle || {}));
    var _c = Badge_read(offset || [], 2), leftOffset = _c[0], topOffset = _c[1];
    if (leftOffset) {
        dotStyle.marginRight = -leftOffset;
    }
    if (topOffset) {
        dotStyle.marginTop = topOffset;
    }
    var getDom = function () {
        var _a, _b;
        if ((0,is/* isObject */.Kn)(count)) {
            return (react.createElement("span", { className: (0,classNames/* default */.Z)(prefixCls + "-custom-dot", dotClassName), style: dotStyle }, count));
        }
        var colorStyle = !color || InnerColors.indexOf(color) > -1 ? {} : { backgroundColor: color };
        // display a red dot if color and status are NOT set
        if (text && !color && !status) {
            return (react.createElement("span", { className: (0,classNames/* default */.Z)(prefixCls + "-text", dotClassName), style: dotStyle }, text));
        }
        if (status || (color && count <= 0)) {
            return (react.createElement("span", { className: prefixCls + "-status-wrapper" },
                react.createElement("span", { className: (0,classNames/* default */.Z)(prefixCls + "-status-dot", (_a = {},
                        _a[prefixCls + "-status-" + status] = status,
                        _a[prefixCls + "-color-" + color] = color,
                        _a), dotClassName), style: __assign(__assign({}, colorStyle), dotStyle) }),
                text && react.createElement("span", { className: prefixCls + "-status-text" }, text)));
        }
        if ((dot || color) && count > 0) {
            return (react.createElement(CSSTransition/* default */.Z, { classNames: "badge-zoom", in: dot || !!color, timeout: 200, appear: true, mountOnEnter: true, unmountOnExit: true },
                react.createElement("span", { className: (0,classNames/* default */.Z)(prefixCls + "-dot", (_b = {},
                        _b[prefixCls + "-color-" + color] = color,
                        _b), dotClassName), style: __assign(__assign({}, colorStyle), dotStyle) })));
        }
        return (react.createElement(Count, { prefixCls: prefixCls, className: (0,classNames/* default */.Z)(prefixCls + "-number", dotClassName), style: __assign(__assign({}, colorStyle), dotStyle), maxCount: maxCount, count: count }));
    };
    return (react.createElement("span", __assign({ className: (0,classNames/* default */.Z)(prefixCls, (_a = {},
            _a[prefixCls + "-status"] = status,
            _a[prefixCls + "-no-children"] = !children,
            _a[prefixCls + "-rtl"] = rtl,
            _a), className), ref: ref, style: style }, restProps),
        children,
        getDom()));
}
var BadgeComponent = (0,react.forwardRef)(Badge);
BadgeComponent.displayName = 'Badge';
/* harmony default export */ var es_Badge = (BadgeComponent);


/***/ }),

/***/ 87629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Carousel; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Carousel/indicator.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



function CarouselIndicator(props, ref) {
    var _a, _b;
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var className = props.className, _c = props.type, type = _c === void 0 ? 'line' : _c, _d = props.count, count = _d === void 0 ? 2 : _d, _e = props.activeIndex, activeIndex = _e === void 0 ? 0 : _e, _f = props.position, position = _f === void 0 ? 'bottom' : _f, _g = props.trigger, trigger = _g === void 0 ? 'click' : _g, onSelectIndex = props.onSelectIndex;
    var prefixCls = getPrefixCls('carousel-indicator');
    var indicatorContent = [];
    if (type === 'slider') {
        var step = 100 / count;
        indicatorContent.push(react.createElement("span", { key: 0, style: { width: step + "%", left: activeIndex * step + "%" }, className: (0,_util_classNames/* default */.Z)(prefixCls + "-item", prefixCls + "-item-active") }));
    }
    else {
        for (var i = 0; i < count; i++) {
            indicatorContent.push(react.createElement("span", { key: i, "data-index": i, className: (0,_util_classNames/* default */.Z)(prefixCls + "-item", (_a = {},
                    _a[prefixCls + "-item-active"] = i === activeIndex,
                    _a)) }));
        }
    }
    var wrapperProps = (_b = {
            ref: ref,
            className: (0,_util_classNames/* default */.Z)(prefixCls, prefixCls + "-" + type, prefixCls + "-" + position, className)
        },
        _b[trigger === 'click' ? 'onClick' : 'onMouseMove'] = function (event) {
            event.preventDefault();
            if (type === 'slider') {
                // clear up effect from event bubbling
                if (event.target === event.currentTarget) {
                    var _a = event.currentTarget.getBoundingClientRect(), startX = _a.x, width = _a.width;
                    var offsetX = event.nativeEvent.clientX - startX;
                    var index = ~~((offsetX / width) * count);
                    index !== activeIndex && onSelectIndex(index);
                }
            }
            else {
                var dataIndex = event.target.getAttribute('data-index');
                // Judge if data-index exists at first, event.target can be the wrapper of indicators
                dataIndex && +dataIndex !== activeIndex && onSelectIndex(+dataIndex);
            }
        },
        _b);
    return react.createElement("div", __assign({}, wrapperProps), indicatorContent);
}
var CarouselIndicatorComponent = react.forwardRef(CarouselIndicator);
/* harmony default export */ var indicator = (CarouselIndicatorComponent);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLeft/index.js
var IconLeft = __webpack_require__(42355);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconRight/index.js
var IconRight = __webpack_require__(826);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconUp/index.js
var IconUp = __webpack_require__(2295);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconDown/index.js
var IconDown = __webpack_require__(31944);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useKeyboardEvent.js
var useKeyboardEvent = __webpack_require__(57483);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Carousel/arrow.js
var arrow_assign = (undefined && undefined.__assign) || function () {
    arrow_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return arrow_assign.apply(this, arguments);
};








function CarouselArrow(props, ref) {
    var _a;
    var className = props.className, _b = props.direction, direction = _b === void 0 ? 'horizontal' : _b, _c = props.showArrow, showArrow = _c === void 0 ? 'always' : _c, prev = props.prev, next = props.next, icons = props.icons;
    var getKeyboardEvents = (0,useKeyboardEvent/* default */.Z)();
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var prefixCls = getPrefixCls('carousel');
    var arrowClass = (0,_util_classNames/* default */.Z)(prefixCls + "-arrow", (_a = {},
        _a[prefixCls + "-arrow-hover"] = showArrow === 'hover',
        _a), className);
    var iconPrev = icons && icons.hasOwnProperty('prev') ? (icons.prev) : direction === 'horizontal' ? (react.createElement(IconLeft/* default */.Z, null)) : (react.createElement(IconUp/* default */.Z, null));
    var iconNext = icons && icons.hasOwnProperty('next') ? (icons.next) : direction === 'horizontal' ? (react.createElement(IconRight/* default */.Z, null)) : (react.createElement(IconDown/* default */.Z, null));
    return (react.createElement("div", { ref: ref, className: arrowClass },
        react.createElement("div", arrow_assign({ className: prefixCls + "-arrow-" + (direction === 'vertical' ? 'top' : 'left'), onClick: prev, role: "button", tabIndex: 0 }, getKeyboardEvents({ onPressEnter: prev })), iconPrev),
        react.createElement("div", arrow_assign({ className: prefixCls + "-arrow-" + (direction === 'vertical' ? 'bottom' : 'right'), onClick: next, role: "button", tabIndex: 0 }, getKeyboardEvents({ onPressEnter: next })), iconNext)));
}
var CarouselArrowComponent = react.forwardRef(CarouselArrow);
/* harmony default export */ var arrow = (CarouselArrowComponent);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useInterval.js

function useInterval(callback, delay) {
    var refIntervalId = (0,react.useRef)(null);
    var refSavedCallback = (0,react.useRef)();
    var setUpInterval = function () {
        if (delay !== null) {
            refIntervalId.current = setInterval(function () {
                refSavedCallback.current();
            }, delay);
        }
    };
    var cleanUpInterval = function () {
        refIntervalId.current && clearInterval(refIntervalId.current);
    };
    var resetInterval = function () {
        cleanUpInterval();
        setUpInterval();
    };
    // Remember the latest function.
    (0,react.useEffect)(function () {
        refSavedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    (0,react.useEffect)(function () {
        setUpInterval();
        return cleanUpInterval;
    }, [delay]);
    return resetInterval;
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/resizeObserver.js
var resizeObserver = __webpack_require__(68761);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/warning.js
var warning = __webpack_require__(97802);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Carousel/index.js
var Carousel_assign = (undefined && undefined.__assign) || function () {
    Carousel_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Carousel_assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};










var DEFAULT_AUTO_PLAY_INTERVAL = 3000;
var defaultProps = {
    animation: 'slide',
    indicatorType: 'dot',
    indicatorPosition: 'bottom',
    direction: 'horizontal',
    showArrow: 'always',
    trigger: 'click',
    moveSpeed: 500,
    timingFunc: 'cubic-bezier(0.34, 0.69, 0.1, 1)',
};
function Carousel(baseProps, ref) {
    var _a, _b;
    var _c = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _c.getPrefixCls, componentConfig = _c.componentConfig, rtl = _c.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Carousel);
    var style = props.style, className = props.className, children = props.children, currentIndex = props.currentIndex, animation = props.animation, trigger = props.trigger, direction = props.direction, moveSpeed = props.moveSpeed, timingFunc = props.timingFunc, indicatorType = props.indicatorType, indicatorPosition = props.indicatorPosition, indicatorClassName = props.indicatorClassName, showArrow = props.showArrow, miniRender = props.miniRender, arrowClassName = props.arrowClassName, carousel = props.carousel, icons = props.icons, onChange = props.onChange, rest = __rest(props, ["style", "className", "children", "currentIndex", "animation", "trigger", "direction", "moveSpeed", "timingFunc", "indicatorType", "indicatorPosition", "indicatorClassName", "showArrow", "miniRender", "arrowClassName", "carousel", "icons", "onChange"]);
    // TODO 兼容 autoPlaySpeed， 3.x 移除
    var autoPlay = props.autoPlay;
    if (autoPlay && props.autoPlaySpeed) {
        autoPlay = {
            interval: props.autoPlaySpeed,
        };
        (0,warning/* default */.Z)(true, "[Arco Carousel] The 'autoPlaySpeed' property will be removed in the next major version, please use 'autoPlay.interval' instead.");
    }
    var childrenList = react.Children.toArray(children).filter(function (child) {
        return react.isValidElement(child);
    });
    var childrenLength = childrenList.length;
    var refDom = (0,react.useRef)(null);
    var refSliderWrapper = (0,react.useRef)(null);
    var refAnimationTimer = (0,react.useRef)(null);
    var _d = __read((0,react.useState)(typeof currentIndex === 'number' ? getValidIndex(currentIndex) : 0), 2), index = _d[0], setIndex = _d[1];
    var _e = __read((0,react.useState)(index), 2), previousIndex = _e[0], setPreviousIndex = _e[1];
    var _f = __read((0,react.useState)(false), 2), isPause = _f[0], setIsPause = _f[1];
    var _g = __read((0,react.useState)(false), 2), isAnimating = _g[0], setIsAnimating = _g[1];
    var _h = __read((0,react.useState)(null), 2), slideDirection = _h[0], setSlideDirection = _h[1];
    var _j = __read((0,react.useState)({
        sliderWrapper: null,
        indicatorWrapper: null,
    }), 2), computedStyle = _j[0], setComputedStyle = _j[1];
    var mergedIndex = typeof currentIndex === 'number' ? getValidIndex(currentIndex) : index;
    var prevIndex = getValidIndex(mergedIndex - 1);
    var nextIndex = getValidIndex(mergedIndex + 1);
    var autoPlayInterval = typeof autoPlay === 'object' && autoPlay.interval
        ? autoPlay.interval
        : DEFAULT_AUTO_PLAY_INTERVAL;
    (0,react.useEffect)(function () {
        return function () { return refAnimationTimer.current && clearTimeout(refAnimationTimer.current); };
    }, []);
    (0,react.useEffect)(function () {
        slideTo({
            targetIndex: mergedIndex,
        });
    }, [mergedIndex]);
    var resetInterval = useInterval(function () {
        slideTo({
            targetIndex: nextIndex,
        });
    }, autoPlay && !isPause && childrenLength > 1 ? autoPlayInterval : null);
    (0,react.useImperativeHandle)(carousel, function () {
        return {
            dom: refDom.current,
            goto: function (_a) {
                var index = _a.index, isNegative = _a.isNegative, isManual = _a.isManual, resetAutoPlayInterval = _a.resetAutoPlayInterval;
                slideTo({
                    targetIndex: getValidIndex(index),
                    isNegative: isNegative,
                    isManual: isManual,
                    resetAutoPlayInterval: resetAutoPlayInterval,
                });
            },
        };
    });
    function getValidIndex(i) {
        var indexNumber = +i;
        return typeof indexNumber === 'number' && !isNaN(indexNumber)
            ? (indexNumber + childrenLength) % childrenLength
            : i;
    }
    function slideTo(_a) {
        var targetIndex = _a.targetIndex, _b = _a.isNegative, isNegative = _b === void 0 ? false : _b, _c = _a.isManual, isManual = _c === void 0 ? false : _c, _d = _a.resetAutoPlayInterval, resetAutoPlayInterval = _d === void 0 ? false : _d;
        if (!isAnimating && targetIndex !== mergedIndex) {
            setIsAnimating(true);
            setIndex(targetIndex);
            setPreviousIndex(index);
            setSlideDirection(isNegative ? 'negative' : 'positive');
            onChange && onChange(targetIndex, mergedIndex, isManual);
            if (autoPlay && resetAutoPlayInterval) {
                resetInterval();
            }
            refAnimationTimer.current = setTimeout(function () {
                setIsAnimating(false);
                refAnimationTimer.current = null;
            }, moveSpeed);
        }
    }
    function computeStyle() {
        if (animation === 'card') {
            if (refSliderWrapper.current) {
                var sliderElement = refSliderWrapper.current.children[0];
                if (!sliderElement) {
                    return;
                }
                var totalWidth = refSliderWrapper.current.clientWidth;
                var sliderWidth = sliderElement.clientWidth;
                var edge = (totalWidth - sliderWidth) / 2;
                // deltaZ is TranslateZ(-Zpx) of prev/next slider's style
                // perspective / (perspective + deltaZ) = x / X
                var deltaZ = 200;
                var x = totalWidth / 2;
                var X = sliderWidth;
                // avoid getting a huge perspective value
                var perspective = x + 50 >= X ? deltaZ * 4 : (deltaZ * x) / (X - x);
                setComputedStyle({
                    sliderWrapper: {
                        perspective: perspective,
                    },
                    indicatorWrapper: {
                        width: 'auto',
                        left: edge,
                        right: edge,
                    },
                });
            }
        }
        else {
            setComputedStyle({
                sliderWrapper: null,
                indicatorWrapper: null,
            });
        }
    }
    var prefixCls = getPrefixCls('carousel');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, prefixCls + "-indicator-position-" + indicatorPosition, (_a = {},
        _a[prefixCls + "-rtl"] = rtl,
        _a), className);
    var eventHandlers = Object.assign({}, autoPlay && (typeof autoPlay !== 'object' || autoPlay.hoverToPause !== false)
        ? {
            onMouseEnter: function () { return setIsPause(true); },
            onMouseLeave: function () { return setIsPause(false); },
        }
        : null);
    return (react.createElement(resizeObserver/* default */.Z, { onResize: computeStyle },
        react.createElement("div", Carousel_assign({ ref: function (_ref) {
                ref = _ref;
                refDom.current = ref;
            }, className: classNames, style: style }, (0,omit/* default */.Z)(rest, ['autoplay', 'autoPlaySpeed']), eventHandlers),
            react.createElement("div", { ref: refSliderWrapper, style: computedStyle.sliderWrapper, className: (0,_util_classNames/* default */.Z)(prefixCls + "-" + animation, prefixCls + "-" + direction, (_b = {},
                    _b[prefixCls + "-negative"] = slideDirection === 'negative',
                    _b)) }, childrenList.map(function (child, index) {
                var _a;
                var isCurrent = index === mergedIndex;
                var isPrev = index === prevIndex;
                var isNext = index === nextIndex;
                var shouldRenderChild = !miniRender || isCurrent || isPrev || isNext;
                if (!shouldRenderChild) {
                    return null;
                }
                var _b = child.props, childStyle = _b.style, childClassName = _b.className, childOnClick = _b.onClick;
                return react.cloneElement(child, {
                    'aria-hidden': !isCurrent,
                    style: Object.assign({
                        transitionTimingFunction: timingFunc,
                        transitionDuration: moveSpeed + "ms",
                        animationTimingFunction: timingFunc,
                        animationDuration: moveSpeed + "ms",
                    }, childStyle),
                    className: (0,_util_classNames/* default */.Z)(childClassName, (_a = {},
                        _a[prefixCls + "-item-prev"] = isPrev,
                        _a[prefixCls + "-item-next"] = isNext,
                        _a[prefixCls + "-item-current"] = isCurrent,
                        _a[prefixCls + "-item-slide-in"] = animation === 'slide' && slideDirection && isAnimating && isCurrent,
                        _a[prefixCls + "-item-slide-out"] = animation === 'slide' && slideDirection && isAnimating && index === previousIndex,
                        _a)),
                    onClick: function (event) {
                        childOnClick && childOnClick(event);
                        slideTo({
                            targetIndex: index,
                            isNegative: index === prevIndex,
                            isManual: true,
                        });
                    },
                });
            })),
            indicatorType !== 'never' && childrenLength > 1 && (react.createElement("div", { style: computedStyle.indicatorWrapper, className: (0,_util_classNames/* default */.Z)(prefixCls + "-indicator-wrapper", prefixCls + "-indicator-wrapper-" + indicatorPosition) },
                react.createElement(indicator, { className: indicatorClassName, type: indicatorType, count: childrenLength, activeIndex: mergedIndex, position: indicatorPosition, trigger: trigger, onSelectIndex: function (index) {
                        return slideTo({
                            targetIndex: index,
                            isNegative: index < mergedIndex,
                            isManual: true,
                        });
                    } }))),
            showArrow !== 'never' && childrenLength > 1 && (react.createElement(arrow, { className: arrowClassName, direction: direction, showArrow: showArrow, icons: icons, prev: function () {
                    return slideTo({
                        targetIndex: prevIndex,
                        isNegative: true,
                        isManual: true,
                    });
                }, next: function () {
                    return slideTo({
                        targetIndex: nextIndex,
                        isManual: true,
                    });
                } })))));
}
var CarouselComponent = react.forwardRef(Carousel);
CarouselComponent.displayName = 'Carousel';
/* harmony default export */ var es_Carousel = (CarouselComponent);


/***/ }),

/***/ 11367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconAppsComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-apps")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    strokeLinejoin: "round",
    d: "M7 7H20V20H7z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    strokeLinejoin: "round",
    d: "M28 7H41V20H28z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    strokeLinejoin: "round",
    d: "M7 28H20V41H7z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    strokeLinejoin: "round",
    d: "M28 28H41V41H28z"
  }));
}

var IconApps = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconAppsComponent);
IconApps.defaultProps = {
  isIcon: true
};
IconApps.displayName = 'IconApps';
/* harmony default export */ __webpack_exports__["Z"] = (IconApps);

/***/ }),

/***/ 9726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconListComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-list")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    d: "M13 24h30M5 12h4m4 24h30M13 12h30M5 24h4M5 36h4"
  }));
}

var IconList = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconListComponent);
IconList.defaultProps = {
  isIcon: true
};
IconList.displayName = 'IconList';
/* harmony default export */ __webpack_exports__["Z"] = (IconList);

/***/ }),

/***/ 70451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var __read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};

function useToggle(defaultValue, reverseValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }
  var _a = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValue), 2),
    state = _a[0],
    setState = _a[1];
  var actions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var reverseValueOrigin = reverseValue === undefined ? !defaultValue : reverseValue;
    var toggle = function toggle() {
      return setState(function (s) {
        return s === defaultValue ? reverseValueOrigin : defaultValue;
      });
    };
    var set = function set(value) {
      return setState(value);
    };
    var setLeft = function setLeft() {
      return setState(defaultValue);
    };
    var setRight = function setRight() {
      return setState(reverseValueOrigin);
    };
    return {
      toggle: toggle,
      set: set,
      setLeft: setLeft,
      setRight: setRight
    };
    // useToggle ignore value change
    // }, [defaultValue, reverseValue]);
  }, []);
  return [state, actions];
}
/* harmony default export */ __webpack_exports__["Z"] = (useToggle);

/***/ }),

/***/ 57478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ScatterChart; }
/* harmony export */ });
/* harmony import */ var _generateCategoricalChart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48902);
/* harmony import */ var _cartesian_Scatter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74008);
/* harmony import */ var _cartesian_XAxis__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3023);
/* harmony import */ var _cartesian_YAxis__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75358);
/* harmony import */ var _cartesian_ZAxis__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26657);
/* harmony import */ var _util_CartesianUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97187);
/**
 * @fileOverview Scatter Chart
 */






var ScatterChart = (0,_generateCategoricalChart__WEBPACK_IMPORTED_MODULE_0__/* .generateCategoricalChart */ .z)({
  chartName: 'ScatterChart',
  GraphicalChild: _cartesian_Scatter__WEBPACK_IMPORTED_MODULE_1__/* .Scatter */ .b,
  defaultTooltipEventType: 'item',
  validateTooltipEventTypes: ['item'],
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: _cartesian_XAxis__WEBPACK_IMPORTED_MODULE_2__/* .XAxis */ .K
  }, {
    axisType: 'yAxis',
    AxisComp: _cartesian_YAxis__WEBPACK_IMPORTED_MODULE_3__/* .YAxis */ .B
  }, {
    axisType: 'zAxis',
    AxisComp: _cartesian_ZAxis__WEBPACK_IMPORTED_MODULE_4__/* .ZAxis */ .d
  }],
  formatAxisMap: _util_CartesianUtils__WEBPACK_IMPORTED_MODULE_5__/* .formatAxisMap */ .t9
});

/***/ })

}]);